<nz-layout>
  <app-menu />
  <nz-content>
    <router-outlet />
  </nz-content>
  <app-footer />
</nz-layout>
